import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49d9dc6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  span: 24,
  class: "flex gap-2"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "image-layer" }
const _hoisted_4 = { class: "mt-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "border-b" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "w-1/5" }, "FFM Code"),
  /*#__PURE__*/_createElementVNode("th", { class: "w-1/6" }, "Quantity"),
  /*#__PURE__*/_createElementVNode("th", { class: "w-1/2" }, "Artworks"),
  /*#__PURE__*/_createElementVNode("th", { class: "w-1/12" })
], -1))
const _hoisted_6 = { class: "w-1/5 pr-3" }
const _hoisted_7 = { class: "pr-3" }
const _hoisted_8 = { class: "flex gap-2 flex-wrap py-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Add Item ")
const _hoisted_11 = { class: "flex w-full justify-end mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentCopy = _resolveComponent("DocumentCopy")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_UploadDesign = _resolveComponent("UploadDesign")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_save_button = _resolveComponent("save-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ARTWORK_SPACES, (artwork) => {
        return (_openBlock(), _createElementBlock("div", {
          key: artwork,
          class: "overflow-hidden"
        }, [
          (_ctx.item[artwork])
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "image-display p-0.5 overflow-hidden",
                onClick: ($event: any) => (_ctx.copyToClipboardV2(_ctx.imageUrl(_ctx.item[artwork])))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_icon, {
                    size: 24,
                    color: "#0070ba"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DocumentCopy)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_el_image, {
                  src: _ctx.imageUrl(_ctx.item[artwork], true, 400),
                  class: "object-cover w-full h-auto",
                  title: "Click to copy"
                }, null, 8, ["src"])
              ], 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("table", null, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCatalogs, (item, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("tr", {
            key: index,
            class: "border-b"
          }, [
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_el_input, {
                modelValue: item.catalogCode,
                "onUpdate:modelValue": ($event: any) => ((item.catalogCode) = $event),
                placeholder: "FFM Code",
                class: "order-item-input w-full"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_el_input_number, {
                modelValue: item.quantity,
                "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                min: 1,
                max: 99999
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ARTWORK_SPACES, (artwork) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "image h-full",
                    key: artwork
                  }, [
                    (item.artworks[artwork] && !_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_UploadImage, {
                          key: 0,
                          setData: item.artworks,
                          itemIndex: index,
                          data: item.artworks[artwork],
                          artwork: artwork,
                          onChangeArtwork: _ctx.changeArtwork,
                          class: "border order-artwork-upload",
                          permission: "all"
                        }, null, 8, ["setData", "itemIndex", "data", "artwork", "onChangeArtwork"]))
                      : (_openBlock(), _createBlock(_component_UploadDesign, {
                          key: 1,
                          onUploaded: _ctx.uploaded,
                          artworkName: artwork,
                          itemIndex: index,
                          class: "order-artwork-upload"
                        }, null, 8, ["onUploaded", "artworkName", "itemIndex"]))
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_el_button, {
                class: "mt-4",
                type: "danger",
                onClick: ($event: any) => (_ctx.onRemoveItem(index))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ], 512)), [
            [_directive_loading, _ctx.loading]
          ])
        }), 128))
      ]),
      _createVNode(_component_el_button, {
        class: "mt-4 w-full",
        type: "primary",
        plain: "",
        onClick: _ctx.onAddItem
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_save_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSaveCatalogs()))
      })
    ])
  ], 64))
}